<template>
	<v-data-table
		id="customers-page-overview-user-table"
		:headers="headers"
		:items="lastOptInUsersTable"
		hide-default-footer
		class="theme-table"
	>
		<template v-slot:item.optin="{ item }">
			<span v-show="item.optin" class="text-success">Oui</span>
			<span v-show="!item.optin" class="text-danger">Non</span>
		</template>
		<template v-slot:item.segments="{ item }">
			<v-tooltip bottom v-for="(seg, sgeid) in item.segments" :key="sgeid">
				<template v-slot:activator="{ on, attrs }">
					<span  class="segment-item mr-2"
						v-bind="attrs"
						v-on="on"
						:class="{
							'segment-color-green' : seg.color === 'green',
							'segment-color-orange' : seg.color === 'orange',
							'segment-color-purple' : seg.color === 'purple',
							'segment-color-blue' : seg.color === 'blue',
							'segment-color-green-dark' : seg.color === 'green-dark',
							'segment-color-pink' : seg.color === 'pink'
						}"
					/>
				</template>
				<span>{{seg.label}}</span>
			</v-tooltip>
		</template>
		<!-- <template v-slot:item.action="{ item }">
			<v-menu offset-y content-class="table-menu">
				<template v-slot:activator="{ on, attrs }">
					<v-btn v-bind="attrs" v-on="on" class="table-menu-trigger">
						Action <v-icon small>expand_more</v-icon>
					</v-btn>
				</template>
				<v-list>
					<v-list-item link>
						<v-list-item-title>Modifier</v-list-item-title>
					</v-list-item>
					<v-list-item link>
						<v-list-item-title>Archiver</v-list-item-title>
					</v-list-item>
					<v-list-item link>
						<v-list-item-title>Détails</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</template> -->
	</v-data-table>
</template>

<script type="text/javascript">

    export default {
        components: {
        	
        },
        props : {
            
        },
        data () {
            return {
                headers : [
					{
						text : 'Prénom',
						sortable : true,
						value : 'firstname'
					},
					{
						text : 'Nom',
						sortable : true,
						value : 'lastname'
					},
					{
						text : 'Email',
						sortable : true,
						value : 'email'
					},
					{
						text : "Date d'inscription",
						sortable : true,
						value : 'created_at'
					},
					{
						text : 'Téléphone',
						sortable : true,
						value : 'phone_number'
					},
					{
						text : 'Présence moyenne',
						sortable : true,
						value : 'average_visit_duration'
					},
					{
						text : 'Nombre de passages',
						sortable : true,
						value : 'nb_visits'
					},
					{
						text : 'Segments attribués',
						sortable : true,
						value : 'segments'
					},
					{
						text : 'Opt-in',
						sortable : true,
						value : 'optin'
					},
					// {
					// 	text : 'Options',
					// 	sortable : false,
					// 	value : 'action'
					// }
                ]
            }
        },
        computed : {
            // lastOptInUsersTable () {
            // 	return this.$store.state.userOverview.lastOptInUsersTable;
            // }
			filterSearch () {
        		return this.$store.state.userOverview.overviewFilters.search;
        	},
        	filterSegment () {
        		return this.$store.state.userOverview.overviewFilters.selectedSegments;
        	},
			lastOptInUsersTable () {
				if(this.$store.state.customer.customers !== null){
					return this.$store.state.customer.customers.slice(0, 10);
				}
				else {
					return false;
				}
            },
        },
        created () {
            
        },
        methods : {
            
        }
    }

</script>

<style lang="scss">
	#customers-page-overview-user-table {
		.segment-item {
			display: inline-block;
			border-radius : 50%;
			width : 22px;
			height : 22px;

			&.segment-color-green {
				background-color : $green-lighten-1;
			}
			&.segment-color-orange {
				background-color : $orange-lighten-1;
			}
			&.segment-color-purple {
				background-color : $purple-alt;
			}
			&.segment-color-blue {
				background-color : $blue-base;
			}
			&.segment-color-green-dark {
				background-color : $green-dark;
			}
			&.segment-color-pink {
				background-color : $pink-base;
			}
		}

		.table-menu-trigger {
			background-color : $purple-lighten-3-3;
			color : $black-base;
			box-shadow : none;
			border-radius : 50px;
			font-size : 12px;
			text-transform : initial;
			padding : 5px 15px;
			height : fit-content;
			transition-duration : 0.2s;

			i{
				position : relative;
				top: 1px;
				color : $black-base;
			}

			&:hover, &:focus {
				background-color : $purple-lighten-1;
				color : white;
				i{
					color : white;
				}
			}
		}

	}

	.table-menu {
		box-shadow : none !important;
		border-radius : 16px !important;
		border: $border-purple;
		margin-top : 3px;

		.v-list {
			padding-top: 0px;
			padding-bottom: 0px;

			&>.v-list-item {
				min-height : initial;
				text-align : center;
				padding : 5px 10px;
				.v-list-item__title {
					color : $purple-alt;
					font-size : 12px;
				}
			}

			&>.v-list-item:nth-child(2n) {
				background-color : $purple-lighten-3-3;
			}
		}
	}

</style>